﻿import { RuntimeInfo } from 'runtime/data/runtimeinfo';

export class RuntimeInfoRequested {
    static eventName() { return 'RuntimeInfoRequested'; }

    public value: RuntimeInfo = null;

    eventName = RuntimeInfoRequested.eventName;
}